import { createFileRoute } from '@tanstack/react-router'
import { diarySearchSchema } from '@/features/filter-diary/model/diarySearch'
import { StudentDiaryPage } from '@/pages/student-diary/ui/StudentDiaryPage'

export const Route = createFileRoute('/my-diary')({
  validateSearch: diarySearchSchema,
  component: StudentDiaryPage,
})
